export default __webpack_public_path__ + "static/media/logoPrinterConnectNovo.5105c1e9.png";